import { Image } from '@cian/ui-kit/image';
import classNames from 'classnames';
import * as React from 'react';

import styles from './Gallery.css';
import { Carousel, IAutoScrollSettings, TMedia } from '../../../../../shared/components/Carousel';
import { IOfferHelperProps } from '../../types/offer-card';

interface IGalleryProps {
  media: TMedia[];
  thumbnails: IOfferHelperProps['thumbnails'];
  deoptimised?: boolean;
  bookedFromCian?: boolean;
  bookedFromDeveloper?: boolean;
  autoScroll: boolean;
  autoScrollSettings?: IAutoScrollSettings;
  onChangeSlide(): void;
}

export function Gallery({
  media,
  thumbnails,
  deoptimised,
  bookedFromCian,
  bookedFromDeveloper,
  autoScroll,
  autoScrollSettings,
  onChangeSlide,
}: IGalleryProps) {
  if (media.length === 0) {
    return (
      <div className={classNames(styles['cont'], styles['cont--empty'])}>
        <Image src="" />
      </div>
    );
  }

  return (
    <div
      data-name="Gallery"
      className={classNames(styles['cont'], !!thumbnails?.length && styles['cont--with-thumbnails'])}
    >
      <Carousel
        autoScroll={autoScroll}
        autoScrollSettings={autoScrollSettings}
        media={media}
        deoptimised={deoptimised}
        bookedFromCian={bookedFromCian}
        bookedFromDeveloper={bookedFromDeveloper}
        onSlideChange={onChangeSlide}
      />
    </div>
  );
}
